import { configureStore } from '@reduxjs/toolkit';
import searchParamsReducer from '../../features/affiliates/searchParamsSlice';
import searchParamsContractsReducer from '../../features/arretTravail/redux/searchParamsSliceContracts';
import searchParamsHistoryReducer from '../../features/arretTravail/redux/searchParamsSliceHistory';
import searchParamsSubscribersReducer from '../../features/arretTravail/redux/searchParamsSliceSubscribers';
import searchParamsAffiliatePrevReducer from '../../pages/Prevoyance/Affiliates/searchParamsSliceAffiliatePrev';

export default configureStore({
    reducer: {
        searchParams: searchParamsReducer,
        searchParamsSubscriber: searchParamsSubscribersReducer,
        searchParamsContract: searchParamsContractsReducer,
        searchParamsHistory: searchParamsHistoryReducer,
        searchParamsAffiliatePrev: searchParamsAffiliatePrevReducer,
    },
});
